export abstract class FilterParameters {
  public abstract get searchParams(): URLSearchParams;
  public abstract isEqualTo(other: FilterParameters): boolean;
}
